import loginModel from "../Model/LoginModel";
import { ServerError } from "../Model/ApiModel";
import { accessTokenModel } from "../Model/AccessTokenModel";

export class LoginViewModel {
    async loginByUsername(username: string, password: string): Promise<any> {
        try {
            var data = await loginModel.loginByUsername(username, password);
            accessTokenModel.updateToken(data);
        } catch (e) {
            if (e instanceof ServerError) {
                if (e.code === 107) {
                    throw new Error("not-found");
                } else if (e.code === 108) {
                    throw new Error("wrong-password");
                } else if (e.code === 211) {
                    throw new Error("invalid-username");
                } else if (e.code === -1) {
                    throw new Error("server-not-connected");
                } else if (e.code === -2) {
                    throw new Error("server-timeout");
                }
            }
            throw new Error("something-wrong");
        }
        return data;
    }

    async loginByPhoneNumber(
        mobile_number: string,
        password: string
    ): Promise<any> {
        try {
            var data = await loginModel.loginByPhoneNumber(mobile_number, password);
            accessTokenModel.updateToken(data);
        } catch (e) {
            if (e instanceof ServerError) {
                if (e.code === 107) {
                    throw new Error("not-found");
                } else if (e.code === 108) {
                    throw new Error("wrong-password");
                } else if (e.code === 213) {
                    throw new Error("invalid-phone");
                } else if (e.code === -1) {
                    throw new Error("server-not-connected");
                } else if (e.code === -2) {
                    throw new Error("server-timeout");
                }
            }
            throw new Error("something-wrong");
        }
        return data;
    }
}

const loginVM = new LoginViewModel();
export default loginVM;